import { useState, useEffect, useRef } from "react";
import NavBar from "./components/NavBar/NavBar";
import LandingBanner from "./components/LandingBanner/LandingBanner";
import About from "./pages/About/About";
import Features from "./pages/Features/Features";
import Updates from "./pages/Updates/Updates";
import ContactForm from "./components/ContactForm/ContactForm";
import JoinWaitlist from "./components/JoinWaitlist/JoinWaitlist";
import Footer from "./components/Footer/Footer";
import { LanguageProvider } from "./context/LanguageContext";
import "normalize.css";
import "./App.css";

const App = () => {
  const [activeSection, setActiveSection] = useState("about");

  const sections = [
    { id: "features", label: "Our Technology", component: <Features /> },
    { id: "about", label: "About Us", component: <About /> },
    // { id: "faq", label: "FAQ", component: <FAQ /> },
    { id: "updates", label: "Latest Updates", component: <Updates /> },
    { id: "signup", label: "Join Our Mailing List", component: <JoinWaitlist /> },
    { id: "contact", label: "Contact Us", component: <ContactForm /> },
  ];

  const sectionsRef = useRef({}); // References to all sections

  // Intersection Observer to update active section
  useEffect(() => {
    const observerOptions = { root: null, threshold: 0.3 };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, observerOptions);

    // Attach observer to all sections
    Object.values(sectionsRef.current).forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!window.location.hash) return;

    const id = decodeURIComponent(window.location.hash.slice(1));
    const timer = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        setActiveSection(id);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <LanguageProvider>
      <div className="app">
        <NavBar activeSection={activeSection} />
        <LandingBanner />
        {sections.map((section) => (
          <section
            key={section.id}
            id={section.id}
            aria-label={section.label}
            className="scroll-mt-24"
            ref={(el) => (sectionsRef.current[section.id] = el)}
          >
            {section.component}
          </section>
        ))}
        <Footer />
      </div>
    </LanguageProvider>
  );
};

export default App;
